import Grid from '@/global/components/ui/Grid'
import dayjs from 'dayjs'
import { FormDatePicker } from 'global/components/Form'
import { SelectEmpresa, SelectFuncionario } from 'global/components/Selects'
import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { useAusenciasOutletContext } from 'pages/Ausencias.context'
import { SubmitHandler } from 'react-hook-form'
import {
    CompensacaoDia,
    compensacaoFeriados,
    createCompensacaoFeriadoSchema,
} from 'service/api'
import { toast } from 'sonner'
import { useStore } from 'store'
import LancamentosAnteriores from '../lancamentos-anteriores'
import invalidateAusenciasQuery from './invalidateAusenciasQuery'

export default function AdicionarCompensacaoFeriado() {
    const { mutateAsync } = compensacaoFeriados.mutations.useCreate()

    const empresaId = useStore(state => state.companyId)
    const funcionarioId = useStore(state => state.employeeId)

    const { data } = useAusenciasOutletContext()
    const rows = data
        ?.filter(
            ({ tipoAusencia }) => tipoAusencia === 'Compensação de feriado',
        )
        ?.filter(item => item.funcionarioId == funcionarioId)

    const handleSubmit: SubmitHandler<CompensacaoDia> = async data => {
        await mutateAsync(
            {
                ...data,
                empresaId,
                funcionarioId,
                dataCompensacao: dayjs(data.dataCompensacao).toDate(),
                dataFeriado: dayjs(data.dataFeriado).toDate(),
            },
            {
                onSuccess: async () => {
                    await invalidateAusenciasQuery()
                    toast.success(
                        'Compensação de feriado adicionada com sucesso!',
                    )
                },
                onError: e => {
                    toast.error(e.message)
                },
            },
        )
    }

    return (
        <Dialog.Root
            width="lg"
            onSubmit={handleSubmit}
            schema={createCompensacaoFeriadoSchema}
            defaultValues={{
                empresaId,
                funcionarioId,
            }}
            open={hasPermission(['create', 'CompensaçãoDeFeriados'])}
        >
            <Dialog.Title>Compensação de feriado</Dialog.Title>
            <Dialog.Content>
                <Grid container className="mb-8">
                    <Grid item xs={12}>
                        <SelectEmpresa variant="form" />
                    </Grid>
                    <Grid item xs={12}>
                        <SelectFuncionario variant="form" />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormDatePicker
                            label="Data da compensação"
                            name="dataCompensacao"
                            type="date"
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormDatePicker
                            label="Data do feriado"
                            name="dataFeriado"
                            type="date"
                        />
                    </Grid>
                </Grid>
                <LancamentosAnteriores rows={rows} />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
